import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { GlobalState } from '~reducers';

export function useBaseEventProperties(): Record<string, unknown> {
	const { userId, email, business, roleName } = useSelector(
		(state: GlobalState) => state.session,
	);

	return useMemo(
		() => ({
			userId,
			email,
			businessId: business?.id,
			businessName: business?.name,
			userRole: roleName,
		}),
		[userId, email, business?.id, business?.name, roleName],
	);
}
